<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
// $('.Gender .facets__list .facets__item').each(function () {
//   const labelText = $(this).find('label').text().toLowerCase();
  
//   if (labelText.includes('boys') || labelText.includes('girls')) {
//     $(this).show();
//   } else {
//     $(this).hide();
//   }
// });
let hasRelevantLabel = false;
$('.Gender .facets__list .facets__item').each(function () {
  const labelText = $(this).find('label').text().toLowerCase();
  if (labelText.includes('boys') || labelText.includes('girls')) {
    $(this).show();
    hasRelevantLabel = true;
  } else {
    $(this).hide();
  }
});
if (hasRelevantLabel) {
  $('.Gender').show();
} else {
  $('.Gender').hide();
}

